export default "//file.bilionpass.com/japandx-portal/0.1.15/static/img/hr.fc8df413-4061ec.png";